import { createReleaseManager } from "./CreateRelease.slice";

export const createReleaseActions = { ...createReleaseManager.actions };
